import {LfAtXmlSerializerOptions} from 'lf-at-theme';

export const XML_SERIALIZER_OPTIONS: LfAtXmlSerializerOptions = {
  validateAllowedValues: false, //These are validated on submit.
};
